import { ReportClient } from './../_models/reports/report-client.model';
import { ReportStudentFilter } from './../_models/reports/report-student-filter.model';
import { ReportTutorFilter } from './../_models/reports/report-tutor-filter.model';
import { ReportCoordinatorFilter } from './../_models/reports/report-coordinator-filter.model';
import { ReportType } from './../_models/reports/report-type.model';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReportDataService {

  private _reportListUpdated: Subject<boolean> = new Subject<false>();
  private _clientListUpdated: Subject<boolean> = new Subject<false>();
  
  public reports: Array<ReportType> = new Array<ReportType>();
  public coordinatorList: Array<ReportCoordinatorFilter> = new Array<ReportCoordinatorFilter>();
  public tutorList: Array<ReportTutorFilter> = new Array<ReportTutorFilter>();
  public studentList: Array<ReportStudentFilter> = new Array<ReportStudentFilter>();
  public clientList: Array<ReportClient> = new Array<ReportClient>();

  public clientUser: any;
  public referrerList: any = [];

  constructor() { }

  public setReports(reports: Array<ReportType>): void {
    this.reports = reports;
    this._reportListUpdated.next(true);
  }

  public setClientList(clientList: Array<ReportClient>): void {
    clientList.forEach(item => item.dropdownDisplay = item.clientName + " (" + item.clientId + ")");
    this.clientList = clientList;
    this._clientListUpdated.next(true);
  }

  public reportListUpdated(): Observable<boolean> {
    return this._reportListUpdated;
  }

  public clientListUpdated(): Observable<boolean> {
    return this._clientListUpdated;
  }
}
